import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WaitlistService from '../../services/waitlistService';
import { useStore } from '../../context/StoreContext';
import { BRAND } from '../../theme/brandTokens';

const WaitlistOfferClaimPage = () => {
  const { t } = useTranslation();
  const { offerId } = useParams();
  const { storeId } = useStore();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    const claim = async () => {
      try {
        await WaitlistService.claimOffer(offerId, storeId);
        if (!cancelled) setStatus('booked');
      } catch (error) {
        const code = error?.response?.data?.errorCode || error?.response?.data?.ErrorCode;
        if (!cancelled) {
          setStatus(code === 5021 || code === 'WaitlistOfferUnavailable' ? 'taken' : 'error');
        }
      }
    };
    if (offerId) claim();
    return () => {
      cancelled = true;
    };
  }, [offerId, storeId]);

  return (
    <Box sx={{ minHeight: '70vh', display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
      <Paper sx={{ p: { xs: 2.5, sm: 4 }, maxWidth: 560, width: '100%', borderRadius: 3 }}>
        {status === 'loading' ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress sx={{ color: BRAND.accent }} /></Box>
        ) : status === 'booked' ? (
          <Alert severity="success">{t('waitlistOfferPage.success')}</Alert>
        ) : status === 'taken' ? (
          <Alert severity="warning">{t('waitlistOfferPage.alreadyBooked')}</Alert>
        ) : (
          <Alert severity="error">{t('waitlistOfferPage.error.claim')}</Alert>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {t('waitlistOfferPage.claimHint')}
        </Typography>
      </Paper>
    </Box>
  );
};

export default WaitlistOfferClaimPage;
